import { view } from "framer-motion/client";

// src/i18n/locales/ar/common.ts
export const arCommonTranslations = {
	common: {
		languageName: 'العربية',
		languageCode: 'ar',
		notAvailable: 'غير متاح',
		collapse: 'طي',
		expand: 'توسيع',
		cancel: 'إلغاء',
		done: 'تم',
	},
	header: {
		home: 'الرئيسية',
		features: 'المميزات',
		pricing: 'الأسعار',
		testimonials: 'آراء العملاء',
		login: 'تسجيل الدخول'
	},
	footer: {
		description: 'حلول قوائم رقمية حديثة للمطاعم التي ترغب في الارتقاء بتجربة عملائها وتبسيط العمليات.',
		product: 'المنتج',
		features: 'المميزات',
		pricing: 'الأسعار',
		demo: 'العرض التوضيحي',
		company: 'الشركة',
		about: 'من نحن',
		blog: 'المدونة',
		careers: 'وظائف',
		resources: 'موارد',
		documentation: 'التوثيق',
		support: 'الدعم',
		contact: 'اتصل بنا',
		legal: 'قانوني',
		terms: 'شروط الخدمة',
		privacy: 'سياسة الخصوصية',
		cookies: 'سياسة ملفات تعريف الارتباط',
		allRightsReserved: 'جميع الحقوق محفوظة',
		poweredBy: 'تطوير شركة',
	},
	notFound: {
		title: 'الصفحة غير موجودة',
		message: 'الصفحة التي تبحث عنها غير موجودة أو تم نقلها.',
		homeButton: 'العودة إلى الرئيسية'
	},
	weekDays: {
		monday: 'الإثنين',
		tuesday: 'الثلاثاء',
		wednesday: 'الأربعاء',
		thursday: 'الخميس',
		friday: 'الجمعة',
		saturday: 'السبت',
		sunday: 'الأحد',
		short: {
			mon: 'إثن',
			tue: 'ثلا',
			wed: 'أرب',
			thu: 'خمي',
			fri: 'جمع',
			sat: 'سبت',
			sun: 'أحد'
		}
	},
	spiceLevels: {
		none: 'بدون',
		mild: 'خفيف',
		medium: 'متوسط',
		hot: 'حار',
		extra_hot: 'حار جداً'
	},
	restaurant: {
		tabs: {
			info: 'معلومات المطعم',
			menu: 'القائمة',
			reviews: 'التقييمات',
			location: 'الموقع',
			feedback: 'الاقتراحات',
		},
		location: {
			title: 'أين نحن',
			getDirections: 'احصل على الاتجاهات',
			viewOnGoogleMaps: 'عرض على خرائط جوجل',
			mapPlaceholder: 'ستظهر الخريطة هنا في الإصدار النهائي',
			transportOptions: 'خيارات النقل',
			bycar: 'بالسيارة',
			carDescription: 'مواقف سيارات مجانية متوفرة للعملاء. الدخول من الشارع الرئيسي.',
			publicTransport: 'النقل العام',
			publicTransportDescription: 'تتوقف حافلات 10 و 15 و 22 بالخارج مباشرة. محطة المترو على بعد 5 دقائق سيرا على الأقدام.',
			walking: 'المشي',
			walkingDescription: 'نحن على بعد 10 دقائق سيرا على الأقدام من وسط المدينة. اتبع مسار النهر للحصول على طريق جميل.'
		},
		info: {
			about: 'حول',
			reviews: 'التقييمات',
			cuisine: 'المطبخ',
			contactInfo: 'معلومات الاتصال',
			address: 'العنوان',
			phone: 'الهاتف',
			hours: 'ساعات العمل',
			website: 'الموقع الإلكتروني',
			closed: 'مغلق',
			open: 'مفتوح',
			amenities: 'وسائل الراحة',
			viewOnGoogleMaps: 'عرض على خرائط جوجل',
			specialFeatures: 'ميزات خاصة',
			specialFeaturesDescription: 'اكتشف ما الذي يجعل هذا المطعم مميزًا',
			freeWifi: 'واي فاي مجاني',
			freeWifiDescription: 'إنترنت عالي السرعة متاح في جميع أنحاء المطعم.',
			parking: 'موقف سيارات',
			parkingDescription: 'موقف سيارات مجاني متاح للعملاء في ساحتنا الخاصة.',
			outdoorSeating: 'جلسة خارجية',
			outdoorSeatingDescription: 'منطقة جلوس في الفناء جميلة، مثالية للطقس اللطيف.',
			payment: 'خيارات الدفع',
			paymentDescription: 'نقبل جميع بطاقات الائتمان الرئيسية، وApple Pay، وGoogle Pay.',
			description: 'الوصف',
			
		},
		menu: {
			popularCategories: 'الفئات الشائعة',
			viewFullMenu: 'عرض القائمة الكاملة',
			fullMenu: 'القائمة الكاملة',
			exploreAllDishes: 'استكشف مجموعتنا الكاملة من الأطباق',
			popularDescription: 'الأطباق الأكثر محبة من قبل عملائنا',
			moreItems: 'عناصر إضافية',
			noCategories: 'لا توجد فئات قائمة',
			noCategoriesDescription: 'لم يضف هذا المطعم أي فئات قائمة بعد.',
			alreadyInCart: 'المنتج موجود بالفعل في السلة',
			addToCart: 'إضافة',
			orderError: 'فشل في تقديم الطلب. الرجاء المحاولة مرة أخرى.',
		},
		reviews: {
			title: 'تقييمات العملاء',
			overview: 'نظرة عامة على التقييمات',
			filter: 'تصفية التقييمات',
			count: 'تقييم',
			sortBy: 'ترتيب حسب',
			newest: 'الأحدث أولاً',
			highest: 'الأعلى تقييماً',
			lowest: 'الأقل تقييماً',
			loadMore: 'تحميل المزيد من التقييمات',
			writeReview: 'كتابة تقييم',
			helpful: 'مفيد',
			replies: 'ردود',
			filterBy: 'تصفية حسب التقييم',
			allRatings: 'جميع التقييمات',
			noReviews: 'لم يتم العثور على تقييمات',
			noReviewsMessage: 'لا توجد تقييمات تطابق عامل التصفية الحالي. حاول تعديل معايير التصفية.',
			clearFilters: 'مسح التصفية',
		},
		rating: {
			title: 'تقييمات العملاء',
			basedOn: 'بناءً على {{count}} تقييم',
			poweredBy: 'مدعوم من تقييمات جوجل',
			addRate: 'أضف تقييم',
			showLess: 'عرض أقل',
			showMore: 'عرض جميع التقييمات ({{count}})',
		},

		loading: 'جاري تحميل معلومات المطعم...',
		notFound: {
			title: 'المطعم غير موجود',
			message: 'عذرًا، لم نتمكن من العثور على المطعم الذي تبحث عنه.',
			homeButton: 'العودة إلى الرئيسية'
		},
	},
	menuItem: {
		noIngredients: 'لا توجد معلومات متاحة عن المكونات',
		noNutritionals: 'لا توجد معلومات غذائية متاحة',
		noVariants: 'لا توجد خيارات متاحة',
		noCustomization: 'هذا العنصر لا يحتوي على خيارات تخصيص',
		noDetails: 'لا توجد تفاصيل إضافية متاحة',
		calorie: 'سعرة حرارية',
		calories: 'سعرات حرارية',
		theCalories: 'السعرات الحرارية',
		calorieUnit: 'سعرة حرارية',
		unavailable: 'غير متوفر',
		addToOrder: 'إضافة إلى الطلب',
		cartDisabled: 'السلة معطلة',
		alreadyInCart: 'المنتج موجود بالفعل في السلة',
		price: 'السعر',
		addons: 'الإضافات',
		each : 'لكل واحد',
		show: 'عرض',
		hide: 'إخفاء',
		details: 'التفاصيل',
		ingredients: 'المكونات',
		nutrition: 'التغذية',
		dietary: 'الحمية',
		customize: 'تعديلات',
	},
	share: {
		title: 'مشاركة المطعم',
		copyLink: 'نسخ الرابط',
		whatsapp: 'واتساب',
		facebook: 'فيسبوك',
		twitter: 'تويتر',
		telegram: 'تليجرام',
		email: 'بريد إلكتروني',
		linkCopied: 'تم نسخ الرابط!'
	},
	menu: {
		loading: 'جاري تحميل القائمة...',
		searchPlaceholder: 'البحث في عناصر القائمة...',
		noResults: 'لا توجد نتائج',
		noSearchResults: 'لا توجد نتائج بحث',
		noSearchResultsDescription: 'لا توجد عناصر تطابق معايير البحث الخاصة بك. جرب تعديل مصطلحات البحث.',
		tryDifferentSearch: 'جرب مصطلح بحث مختلف أو قم بمسح الفلاتر',
		filters: 'الفلاتر',
		clearFilters: 'مسح الفلاتر',
		dietaryPreferences: 'التفضيلات الغذائية',
		vegetarian: 'نباتي',
		vegan: 'نباتي صارم',
		glutenFree: 'خالي من الغلوتين',
		dietaryInfo: 'حول علامات التفضيلات الغذائية',
		dietaryInfoDesc: 'تشير هذه العلامات إلى الخصائص الغذائية لهذا العنصر. تحقق دائماً مع الطاقم إذا كان لديك حساسية معينة أو تقييدات غذائية.',
		noDietaryPreferences: 'لا توجد معلومات غذائية',
		noDietaryPreferencesDesc: 'هذا العنصر لا يحتوي على أي معلومات تفضيلات غذائية متاحة.',
		featuredItems: 'العناصر المميّزة',
		featuredDescription: 'أطباقنا الأكثر شعبية وتوصيات الشيف',
		clickToCustomize : 'انقر للتخصيص',
		quickOrder: 'طلب سريع',
		addToOrder: 'إضافة إلى الطلب',
		customizeYourOrder: 'خصص طلبك أدناه',
		categories: 'الفئات',
		allCategories: 'جميع الفئات',
		ingredients: 'المكونات',
		nutritionalInfo: 'معلومات غذائية',
		noItems: 'لا توجد عناصر في هذه الفئة',
		item: 'عنصر',
		items: 'عناصر',
		spiceLevel: 'مستوى التوابل',
		calorie: 'سعرة حرارية',
		preparationTime: 'وقت التحضير',
		minute: 'دقيقة',
		minutes: 'دقائق',
		viewDetails: 'عرض التفاصيل',
		itemDetails: 'تفاصيل العنصر',
		variant : 'الخيارات',
		unavailable: 'غير متوفر',
		popular: 'شعبي',
		itemCards: 'بطاقات العناصر',
		customizations: 'تخصيصات',
		customizeItem: 'تخصيص العنصر',
		quantity: 'الكمية',
		willCreateCards: 'سيتم إضافة {{count}} عنصر إلى هذه البطاقة',
		none: 'لا شيء',
		customizeAndAdd: 'تخصيص وإضافة إلى الطلب',
		addWithoutCustomization: 'إضافة بدون تخصيص',
		saveToOrder: 'حفظ في الطلب',
		totalPrice: 'السعر الإجمالي',
		customizationOptions: 'خيارات التخصيص',
		selectUpTo: 'اختر حتى',
		moreOptions: 'خيارات أخرى',
		customizePrompt: 'استخدم زر "تخصيص وإضافة" أدناه لتخصيص هذا العنصر',
		maxReached: 'تم الوصول للحد الأقصى',
		availableVariants: 'الخيارات المتاحة',
		customize: 'تخصيص',
		zoomImage: 'تكبير الصورة',
		viewMode: {
			grid: 'عرض الشبكة',
			list: 'عرض القائمة'
		},
		SubcategoryStyle: {
			tabs: 'عرض التبويبات',
			dropdown: 'عرض القائمة المنسدلة'
		},

		showMore: 'عرض المزيد',
		showLess: 'عرض أقل',
		expandAll: 'توسيع الكل',
		collapseAll: 'طي الكل',
		view: 'عرض',
		youMightAlsoLike: 'قد يعجبك أيضاً',
		
		// Cart translations
		cart: {
			save : 'حفظ',
			title: 'سلة التسوق',
			empty: 'سلة التسوق فارغة',
			item: 'عنصر',
			items: 'عناصر',
			total: 'المجموع',
			checkout: 'الدفع',
			orderViaWhatsApp: 'اطلب عبر واتساب',
			note: 'ملاحظة',
			addNote: 'إضافة ملاحظة',
			editNote: 'تعديل الملاحظة',
			noteExample: 'مثل: بدون بصل، حار إضافي...',
			mobile: 'رقم الجوال',
			mobilePlaceholder: '٦٥٤ ٣٢١ ٠٥ ١+',
			deliveryLocation: 'موقع التوصيل',
			addressPlaceholder: 'أدخل عنوان التوصيل...',
			or: 'أو',
			and : 'و',
			clearAll: 'مسح الكل',
			yourCart: 'سلة التسوق الخاصة بك',
			orderType: 'نوع الطلب',
			delivery: 'التوصيل',
			deliveryZone: 'منطقة التوصيل',
			selectZone: 'اختر منطقة التوصيل',
			deliveryFee: 'رسوم التوصيل',
			subtotal: 'المجموع الفرعي',
			pickup: 'الاستلام',
			pickupInstructions: 'تعليمات الاستلام',
			pickupDetails: 'سيكون طلبك جاهزاً للاستلام من مطعمنا..',
			expectedArrivalTime: 'وقت الوصول المتوقع',
			arrivalTimeHint: 'متى تتوقع الوصول للاستلام؟',
			minutes: 'دقيقة',
			hour: 'ساعة',
			newOrder: 'طلب جديد',
			thankYou: 'شكراً لك على طلبك!',
			confirmClearCartTitle: "هل أنت متأكد أنك تريد إفراغ السلة؟",
			confirmClearCartMessage: "سيؤدي هذا الإجراء إلى إزالة جميع العناصر من السلة. لا يمكنك التراجع.",
			orderNoteLabel: 'ملاحظة الطلب',
			orderNotePlaceholder: 'أضف أي تعليمات تريد أن يراها المطعم',
			cancel: "إلغاء",
			confirm: "تأكيد",
			firstName: 'الاسم الأول',
			lastName: 'اسم العائلة',
			firstNamePlaceholder: 'أدخل اسمك الأول',
			lastNamePlaceholder: 'أدخل اسم عائلتك',
			notePlaceholder: 'أضف تعليمات خاصة لطلبك',
			location: {
				get: 'الحصول على الموقع الحالي',
				getting: 'جاري الحصول على الموقع...',
				detected: 'تم اكتشاف الموقع بنجاح',
				current: 'الموقع الحالي',
				manual: 'العنوان اليدوي',
				error: 'لا يمكن الحصول على الموقع. يرجى الإدخال يدوياً.',
				routeToYourLocation: 'المسار إلى موقعك',
				distance: 'المسافة',
				time: 'الوقت',
				deliveryRoute: 'مسار التوصيل',
				yourLocation: 'موقعك',
				locationNotAvailable: 'معلومات الموقع غير متاحة',
				mapRequiresApiKey: 'تتطلب الخريطة مفتاح API من Google Maps. يرجى التحقق من وثائق الإعداد.',
				gettingRoute: 'جاري الحصول على المسار...',
				navigateHere: 'التوجيه إلى هنا',
				getMyLocation: 'الحصول على موقعي',
				navigateFromMyLocation: 'التوجيه من موقعي',
				showRoute: 'عرض المسار',
				hideRoute: 'إخفاء المسار',
				startNavigation: 'بدء التنقل',
				navigationActive: 'التنقل مفعل',
				routeTo: 'المسار إلى {{restaurantName}}',
				locationDetails: 'تفاصيل الموقع',
				pickupLocation: 'موقع الاستلام',
				locationMap: 'خريطة الموقع',
				restaurant: 'المطعم',
				navigateToRestaurant: 'التوجه إلى المطعم',
				refresh: 'تحديث الموقع'

			},
		},
		
		myCart : "سلة التسوق الخاصة بي",
		shoppingCart: 'سلة التسوق',
		emptyCart: 'سلة التسوق فارغة',
		emptyCartMessage: 'أضف بعض العناصر اللذيذة للبدء',
		startShopping: 'ابدأ التسوق',
		startOrdering: 'ابدأ الطلب',
		yourOrder: 'طلبك',
		specialInstructions: 'تعليمات خاصة لهذا العنصر',
		addNote: 'إضافة ملاحظة',
		editNote: 'تعديل الملاحظة',
		removeItem: 'إزالة العنصر',
		note: 'ملاحظة',
		addNotePrompt: 'أضف تعليمات خاصة لهذا العنصر',
		noteExample: 'مثل: بدون بصل، حار إضافي...',
		done: 'تم',
		checkout: 'إتمام الطلب',
		orderViaWhatsApp: 'اطلب عبر واتساب',
		deliverInformation: 'معلومات التوصيل',
		orderSummary: 'ملخص الطلب',
		customerInfo: 'معلومات العميل',
		mobileNumber: 'رقم الهاتف المحمول',

		enterMobile: 'أدخل رقم هاتفك المحمول',
		mobileRequired: 'رقم الهاتف المحمول مطلوب',
		mobileInvalid: 'يرجى إدخال رقم هاتف صحيح',
		deliveryAddress: 'عنوان التوصيل',
		enterAddress: 'أدخل عنوان التوصيل الكامل',
		addressRequired: 'العنوان مطلوب',
		or: 'أو',
		useCurrentLocation: 'استخدام الموقع الحالي',
		locationCaptured: 'تم التقاط الموقع بنجاح',
		geolocationNotSupported: 'خدمة تحديد الموقع غير مدعومة في متصفحك',
		locationError: 'تعذر الحصول على موقعك. يرجى المحاولة مرة أخرى',
		personalInfo: 'المعلومات الشخصية',
		name: 'الاسم',
		enterName: 'أدخل اسمك',
		tableNumber: 'رقم الطاولة',
		enterTableNumber: 'أدخل رقم الطاولة',
		orderNote: 'ملاحظة الطلب',
		enterOrderNote: 'أي تعليمات خاصة لطلبك',
		tip: 'الإكرامية',
		subtotal: 'المجموع الفرعي',
		tax: 'الضريبة',
		total: 'المجموع الكلي',
		proceedToCheckout: 'المتابعة إلى الدفع',
		placeOrder: 'تأكيد الطلب',
		orderPlaced: 'تم تقديم الطلب بنجاح',
		orderConfirmation: 'تم تقديم طلبك. سيبدأ المطعم في تحضير طلبك قريبًا.',
		continueBrowsing: 'متابعة التصفح',
		orderDetails: 'تفاصيل الطلب',
		addMoreItems: 'إضافة المزيد من العناصر',
		orderAgain: 'اطلب مرة أخرى',

		sortOptions: {
			default: 'افتراضي',
			priceAsc: 'السعر: من الأقل إلى الأعلى',
			priceDesc: 'السعر: من الأعلى إلى الأقل',
			nameAsc: 'الاسم: أ إلى ي',
			nameDesc: 'الاسم: ي إلى أ'
		}
	},
	home: {
		hero: {
			title: 'حوّل تجربة قائمة مطعمك',
			subtitle: 'ارتقِ بخدمة الطعام لديك مع قوائم رقمية تفاعلية تسعد العملاء وتعزز أعمالك',
			primaryCta: 'ابدأ الآن',
			secondaryCta: 'شاهد العرض التوضيحي',
			imageAlt: 'معاينة قائمة المطعم التفاعلية'
		},
		features: {
			title: 'كل ما تحتاجه لتناول الطعام الحديث',
			subtitle: 'توفر منصتنا حلولاً شاملة لرقمنة وتعزيز تجربة مطعمك',
			digitalMenu: {
				title: 'قوائم رقمية تفاعلية',
				description: 'أنشئ قوائم رقمية جميلة وقابلة للتخصيص تعرض عروضك مع صور عالية الجودة وأوصاف مفصلة'
			},
			mobileOrdering: {
				title: 'الطلب عبر الهاتف المحمول',
				description: 'اسمح للعملاء بتصفح قائمتك وتقديم الطلبات مباشرة من هواتفهم الذكية للتناول في المطعم أو الاستلام أو التوصيل'
			},
			analytics: {
				title: 'رؤى العملاء',
				description: 'احصل على بيانات قيمة حول تفضيلات العملاء والعناصر الشائعة وأنماط الطلب لتحسين عملك'
			}
		},
		testimonials: {
			title: 'قصص النجاح',
			subtitle: 'استمع إلى أصحاب المطاعم الذين قاموا بتحويل أعمالهم باستخدام منصتنا',
			items: [
				{
					name: 'أليكس جونسون',
					role: 'المالك',
					restaurantName: 'بيسترو إليغانس',
					content: 'منذ تنفيذ نظام القائمة الرقمية هذا، شهدنا زيادة بنسبة 30٪ في متوسط قيمة الطلب. يحب العملاء التجربة المرئية ويقضي موظفونا وقتًا أقل في شرح عناصر القائمة.'
				},
				{
					name: 'ماريا رودريغيز',
					role: 'رئيس الطهاة',
					restaurantName: 'سبايس فيوجن',
					content: 'أدت القدرة على عرض أطباقنا المتخصصة بصور عالية الجودة إلى زيادة كبيرة في طلباتها. المنصة بديهية لكل من موظفينا وعملائنا.'
				},
				{
					name: 'داوود تشين',
					role: 'المدير',
					restaurantName: 'أوربن بليت',
					content: 'كانت التحليلات التي توفرها هذه المنصة بمثابة تغيير في قواعد اللعبة لأعمالنا. يمكننا الآن اتخاذ قرارات مستندة إلى البيانات حول عروض قائمتنا واستراتيجية التسعير.'
				}
			]
		},
		cta: {
			title: 'هل أنت جاهز لتحديث مطعمك؟',
			description: 'انضم إلى آلاف المطاعم التي تستخدم منصتنا بالفعل لتعزيز تجربة العملاء وزيادة الإيرادات',
			buttonText: 'ابدأ تجربتك المجانية'
		}
	},
	categories: {
		more: 'أكثر',
		subcategories: 'الفئات الفرعية',
		noCategories: 'لا توجد فئات متاحة',
		noCategoriesDescription: 'لم يضف هذا المطعم أي فئات قائمة بعد.',
		ourCategories: 'الفئات المتوفرة لدينا',
		categoriesDescription: 'وصف عن الفئات المتوفرة'
	},
	// Additional translations for LocationMap
	openInMaps: 'فتح الخريطة',
	webMaps: 'خرائط الويب',
	deliveryAddress: 'عنوان التوصيل',
	clearAll: 'مسح الكل',
	activeFilters: 'الفلاتر النشطة',
	feedback: {
		title: 'كيف كانت تجربتك؟',
		subtitle: 'ملاحظاتك تساعدنا في خدمتك بشكل أفضل.',
		description: 'نحن نقدر رأيك! ساعدنا في التحسين من خلال مشاركة تجربتك معنا.',
		itemTitle: 'قيم هذا العنصر',
		branchTitle: 'قيم مطعمنا',
		ratingLabel: 'كيف تقيم تجربتك؟',
		commentLabel: 'تعليقك',
		optional: '(اختياري)',
		itemPlaceholder: 'أخبرنا برأيك في هذا العنصر...',
		branchPlaceholder: 'أخبرنا عن تجربتك الإجمالية...',
		star: 'نجمة',
		stars: 'نجوم',
		submit: 'إرسال التقييم',
		success: 'شكراً لك! تم إرسال تقييمك بنجاح.',
		congratulations: 'تهانينا!',
		appreciateYou: 'نحن نقدرك!',
		error: 'عذراً، حدث خطأ في إرسال تقييمك. يرجى المحاولة مرة أخرى.',
		giveFeedback: 'أعطي تقييم',
		leaveFeedback: 'اترك تقييم',
		leaveDetailedReview: 'اترك تقييماً مفصلاً',
		leaveFeedbackDescription: 'شاركنا أفكارك وساعدنا في تحسين تجربتك',
		quickRating: 'تقييم سريع',
		quickRatingDescription: 'قيم تجربتك الإجمالية بنقرات قليلة',
		anonymous: 'هوية مجهولة 100٪',
		anonymousDescription: 'يتم إرسال تقييمك بشكل مجهول وآمن',
		improving: 'دائماً نتطور',
		improvingDescription: 'نستخدم تقييمك لتحسين خدماتنا بشكل مستمر',
		valued: 'نحن نقدر رأيك',
		valuedDescription: 'كل تقييم يساعدنا في خدمتك بشكل أفضل',
	}
};